import dayjs from 'dayjs';

export const convertPromotions = data => {
  const params = new URLSearchParams();

  params.append('offset', data.page * data.count);
  params.append('limit', data.count);
  params.append('publication_date_from', dayjs(data.beginDate).format('YYYY-MM-DD HH:mm:ss'));
  params.append('publication_date_to', dayjs(data.endDate).format('YYYY-MM-DD HH:mm:ss'));

  if (!data.statusAll && data.statusActive !== data.statusInactive) {
    if (data.statusActive) {
      params.append('is_active', 'true');
    } else if (data.statusInactive) {
      params.append('is_active', 'false');
    }
  }

  if (data.lang !== 'allLanguages') {
    params.append('lang', data.lang);
  }

  return params;
};
